export default __webpack_public_path__ + "static/media/dictionary_mockup_final.1441f7ab.png";